import { render, staticRenderFns } from "./ParticipantEditor.vue?vue&type=template&id=bb81a978&"
import script from "./ParticipantEditor.vue?vue&type=script&lang=ts&"
export * from "./ParticipantEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports